import { render, staticRenderFns } from "./xy-gradual-change-btn.vue?vue&type=template&id=8117d4f8&scoped=true"
import script from "./xy-gradual-change-btn.vue?vue&type=script&lang=js"
export * from "./xy-gradual-change-btn.vue?vue&type=script&lang=js"
import style0 from "./xy-gradual-change-btn.vue?vue&type=style&index=0&id=8117d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8117d4f8",
  null
  
)

export default component.exports